<template>
  <Breadcrumbs
    class=" pa-0"
    :items="breadcrumbs"/>
</template>

<script>
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'

export default {
  name: 'tenderBreadcrumbs',
  data() {
    return {
      exit_confirm: false
    }
  },
  props: {
    file: String,
    dialog: Boolean,
    without_top_padding: Boolean,
    new_tender: Boolean,
    parent_slot: Boolean,
    current_bread: Object,
    parent_bread: Object,
    additional_breads: Array,
    current: String,
    link: [Object, String],
    plan: Boolean,
    checkExit: Function,
    loading: Boolean
  },
  computed: {
    breadcrumbs() {
      let link = !this.dialog ? this.link || this.link_to_tender : ''
      let current_tender = this.getTenderName(this.ready_tender) || this.getTenderName( this.tender) ||
          (this.new_tender ? this.$t('Tenders.TenderCreation')  :  '-')
      let mainParentTo = (!this.checkExit || !this.checkExit()) && !this.dialog ? this.route_to : ''

      let result = [
        {
          text: this.plan ? this.$t('Menu.Planning') : this.tender?.tenderId ? this.$t('Tenders.Tender') : this.$t('Tenders.Tenders'),
          action: this.goTo,
          to: mainParentTo
        },
        {
          text: current_tender ,
          action: this.close,
          to: link
        },
      ]
      if ( this.additional_breads) {
        result.push(...this.additional_breads)
      }
      if ( this.parent_bread ) {
        result.push(this.parent_bread)
      }
      if ( this.current_bread ) {
        result.push(this.current_bread)
      }
      if ( this.current || this.file ) {
        result.push({
          text: this.current || ( this.file ? this.$t('Tenders.DocumentView')  + ' ' + this.file : '–' )
        })
      }
      if ( result.length == 2) {
        result[1].to = ''
      }

      if ( result.some(el => !el.text || el.text == '-' || el.text == '–') ) {
        result?.forEach(el => !el.text || el.text == '-' || el.text == '–' ? el.loading = this.loading : '')
      }
      return result
    },
    tender() {
      return this.$store.getters['getNewTender']
    },
    ready_tender() {
      return this.$store.getters['getTender']
    },
    info() {
      return this.$store.getters['getNewTenderInfo']
    },
    open: {
      get() {
        return this.dialog
      },
      set(val) {
        this.$emit('update:dialog', val)
      }
    },
    link_to_tender() {
      let id = this.$route.params?.id || this.$route.params?.tenderId || this.$route.query?.id
      return id ? { name: 'tenderitem', params: {id, org: this.$route.params.org}, query: {} } : ''
    },
    route_to() {
      if ( this.plan ) {
        return { name: 'planning' , params: {org: this.$route.params.org}}
      } else if (this.info?.mode && !this.new_tender ) {
        return this.link_to_tender
      } else {
        return { name: 'tenders', params: {org: this.$route.params.org}, query: {}}
      }
    },
  },
  methods: {
    getTenderName(item) {
      return item?.tenderNumber ? ' #' + item?.tenderNumber : ''
    },
    submitExit() {
      if (this.dialog) {
        this.open = false
        if ( this.breadcrumbs.length > 2 ) {
          this.$router.push(this.route_to)
          return
        }
      } else {
        this.$router.push(this.route_to)
      }
      this.$store.getters['clearNewTender']
    },
    goTo() {
      if (this.checkExit && this.checkExit()) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.submitExit })
      } else {
        this.submitExit()
      }
    },
    close() {
      if (this.dialog) {
        this.open = false
      }
    }
  },
  components: {
    Breadcrumbs
  }
}
</script>
